// #genai Component-specific styles for SignInFlow (form, buttons, fields).
// Shared guest-flow styles (title, body, etc.) are imported from guestFlow.styles.js.
import { guestFlowBaseStyles, guestFlowThemedStyles } from 'features/guest-access/guestFlow.styles';

const signInFlowStyles = (theme) => ({
  ...guestFlowBaseStyles,
  ...guestFlowThemedStyles(theme),
  guestButton: {
    borderColor: theme.evPalette.ocean[600],
    color: theme.evPalette.ocean[600],
  },
  form: { marginTop: '20px' },
  field: { marginTop: '14px' },
  label: {
    display: 'block',
    color: '#1B202C',
    fontSize: '12px',
    fontWeight: 600,
    marginBottom: '6px',
    '& input': { display: 'block', marginTop: '6px' },
  },
  input: {
    width: '100%',
    height: '36px',
    border: '1px solid #C8CDD7',
    borderRadius: '2px',
    padding: '0 10px',
    fontSize: '14px',
    outline: 'none',
    '&:focus': {
      borderColor: '#007CAD',
      boxShadow: '0 0 0 2px rgba(0, 124, 173, 0.12)',
    },
  },
  actions: { marginTop: '18px' },
  primaryBtn: {
    width: '100%',
    height: '36px',
    border: 'none',
    borderRadius: '2px',
    background: '#007CAD',
    color: '#FFFFFF',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    '&:disabled': { background: '#E0E0E0', color: '#9E9E9E', cursor: 'not-allowed' },
  },
  secondaryBtn: {
    width: '100%',
    height: '36px',
    borderRadius: '2px',
    border: '1px solid #007CAD',
    background: '#FFFFFF',
    color: '#007CAD',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  linkRow: {
    marginTop: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  linkOld: {
    color: '#007CAD',
    fontSize: '12px',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  },
  error: {
    marginTop: '12px',
    color: '#D14343',
    fontSize: '12px',
    minHeight: '16px',
  },
  // #genai Resend button when disabled (cooldown): grey, no pointer.
  actionLinkDisabled: {
    color: '#9E9E9E',
    cursor: 'not-allowed',
  },
});

export default signInFlowStyles;
